<div class="col-xs-12 col-sm-12 col-md-10 col-lg-12 no-padding joinAcc_UK">
  @if (joinAccthankyouData | async; as thankYouData) {
    <div class="joinaccount_thankyou col-xs-12">
      <div class="joinAccount_label padding-B30">{{thankYouData.title}}</div>
      <div class="joinAccount_Rbatext padding-B10">{{thankYouData.text2}}</div>
      <div class="joinAccount_Rbatext padding-B30">{{thankYouData.content}}</div>
      <div class="joinAccount_Rbatext padding-B20">{{thankYouData.paragraphcontent}}</div>
      @if (joinAccResponse?.firstB2BUnit == true) {
        <!-- check cnditonview only -->
        <!-- <div *ngIf="seqirusb2b-uk.rba.permission.firstuser.account == 'VIEWONLY';else otherpermission" class="joinAccount_Rbatext padding-B30 Rbaordermanage">Ordering <span class="joinaccount_ordering">View Only</span> and Financial <span class="joinaccount_financial">View Only</span></div> -->
        <div class="joinAccount_Rbatext padding-B30 Rbaordermanage">Ordering <span class="joinaccount_ordering">View Only</span> and Financial <span class="joinaccount_financial">View Only</span></div>
        <ng-template #otherpermission>
          <div class="joinAccount_Rbatext padding-B30 Rbaordermanage">Ordering <div class="joinaccount_firstOrdering">MANAGE</div> and Financial <div class="joinaccount_firstFinancial">MANAGE</div></div>
        </ng-template>
      } @else {
        <div class="joinAccount_Rbatext padding-B30 Rbaordermanage">Ordering <span class="joinaccount_ordering">{{joinAccResponse?.orderingPermission}}</span> and Financial <span class="joinaccount_financial">{{joinAccResponse?.financialPermission}}</span></div>
      }
      @if (joinAccResponse?.firstB2BUnit == false) {
        @if (joinAccResponse?.adminPermissions && joinAccResponse?.adminPermissions.length > 0) {
          <div class="joinAccount_Rbatext padding-B30">
            <div class="padding-B20">{{thankYouData.h2content}}</div>
            <div class="joinAccount_dynamicId margin-B30">
              @for (admin of joinAccResponse?.adminPermissions; track admin) {
                <div class="rbacentertextjoinaccount padding-B10">{{admin.name}}&nbsp;<span class="permissionmail"><a href=mailto:{{admin.email}}>{{admin.email}}</a></span></div>
              }
            </div>
            <div [innerHTML]="thankYouData.h3content"></div>
          </div>
        } @else {
          <div class="joinAccount_Rbatext padding-B30">
            <div class="padding-B20">You may request changes by contacting<span class="permissionmail"> <a href=mailto:service.uk@seqirus.com>service.uk&#64;seqirus.com</a></span> for this account</div>
          </div>
        }
      }
      <div class="joinAccount_Thankyou-button">
        <a [routerLink]="'/my-account'"><button type="button" class="joinAccount_my-profile">Go To My Dashboard</button></a>
      </div>
    </div>
  }
</div>
